const loadLastViewed = async (recentlyViewed, sectionId) => {
  const list = document.getElementById(`Slider-${sectionId}`);
  const template = document.getElementById(`Template-${sectionId}`);
  await Promise.all(
    recentlyViewed.map(async (item, idx) => {
      const card = template.content.cloneNode(true);
      const gridItem = card.querySelector(".grid__item");
      gridItem.id = `${sectionId}-${idx}`;
      gridItem.style.order = idx + 1;

      await fetch(
        `${window.location.origin}/products/${item.handle}?sections=card-product-section`
      )
        .then((res) => res.text())
        .then((responseText) => {
          const { "card-product-section": prod } = JSON.parse(responseText);
          const html = new DOMParser().parseFromString(prod, "text/html");
          const cardWrapper = html.querySelector(".card-wrapper");
          gridItem.appendChild(cardWrapper);

          list.appendChild(card);
        })
        .then(() => {
          initColorSelector(
            `card-product-section${item.id}`,
            `product-form-card-product-section${item.id}`
          );
        });
    })
  );
};
